import { format } from 'date-fns';
const dateFormats = {
    FULL_DATE_FORMAT: 'MMM dd, yyyy HH:mm',
};
export function formatDate(timestamp, dateFormat = dateFormats.FULL_DATE_FORMAT) {
    return format(new Date(timestamp), dateFormat);
}
export default formatDate;
